import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper } from "@mui/material"
import { tableCellClasses } from '@mui/material/TableCell'
import { styled } from '@mui/material/styles'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		fontSize: 14,
		fontWeight: 'bold'
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14
	},
}))

const WorkerMonitor = ({ data, zones }) => {
  const { t } = useTranslation()

  const containerRef = useRef(null)
  const headerRefs = useRef([])
  const [activeSessionIndex, setActiveSessionIndex] = useState(0)

  const handleScroll = () => {
    const containerTop = containerRef.current.getBoundingClientRect().top

    let currentIndex = 0

    for (let i = 0; i < headerRefs.current.length; i++) {
      const rect = headerRefs.current[i].getBoundingClientRect()
      if (rect.top <= containerTop + 56*2) {
        currentIndex = i
      }
    }
    
    setActiveSessionIndex(currentIndex)
  }

  useEffect(() => {
    const container = containerRef.current
    container.addEventListener('scroll', handleScroll)
    handleScroll()
    return () => container.removeEventListener('scroll', handleScroll)
  }, [])
  
  return (
    <div style={{ width: "100%", height: "100%", backgroundColor: "#FFFFFF", borderRadius: "10px", display: "flex", flexDirection: "column", overflow: "auto", padding: "10px" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>        
        <div><b>Smartwatch Monitor</b></div>
      </div>

      <Paper elevation={0} sx={{ flex: 1, display: "flex", flexFlow: "column", overflow: "auto" }}>
        <TableContainer ref={containerRef} sx={{ flex: 1, overflow: "auto"  }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow sx={{ height: 56 }}>
                <StyledTableCell align="center">{t("smartwatch_worker")}</StyledTableCell>
                <StyledTableCell align="center">{t("smartwatch_zone")}</StyledTableCell>
                <StyledTableCell align="center">{t("smartwatch_alerts")}</StyledTableCell>
                <StyledTableCell align="center">{t("general_lastUpdate")}</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {[
                { session: t("module_confinedSpace"), rows: data.filter((i) => i["in_tunnel"]) },
                { session: "Ground", rows: data.filter((i) => !i["in_tunnel"]) }
              ].map((session, index) => (<>
                <TableRow
                  ref={(el) => (headerRefs.current[index] = el)}
                  style={{ position: activeSessionIndex === index ? "sticky" : "static", top: 57, backgroundColor: "#f5f5f5", }}
                >
                  <StyledTableCell colSpan={4}>{`${session.session}\t👷${session.rows.length}`}</StyledTableCell>
                </TableRow>

                {session.rows.map((row, i) => (
                  <TableRow key={i}>
                    <StyledTableCell align="center">
                      <div style={{ overflow: "hidden", whiteSpace: "nowrap"}}>{row.worker_name}</div>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <div style={{ overflow: "hidden", whiteSpace: "nowrap"}}>{row.zone_name}</div>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <div style={{ overflow: "hidden", whiteSpace: "nowrap"}}>{row.alerts}</div>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <div style={{ overflow: "hidden", whiteSpace: "nowrap"}}>{row.last_update}</div>
                    </StyledTableCell>
                  </TableRow>
                ))}
              </>))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  )
}

export default WorkerMonitor
